<template>
  <v-row
    class="ma-0"
    :class="{
      section:
        !$route.params.bookingId &&
        isUserLoggedIn &&
        $vuetify.breakpoint.smAndUp
    }"
  >
    <v-col cols="12" class="px-10 pt-5" v-if="$vuetify.breakpoint.mdAndUp">
      <span class="doctor-title">Doctor details</span>
    </v-col>
    <v-col cols="12" class="px-2">
      <v-row class="ma-0">
        <v-col
          v-if="!skeletonLoader"
          :cols="$vuetify.breakpoint.mdAndUp ? 6 : 12"
        >
          <doctor-details :profile="profile"></doctor-details>
          <doctor-map
            v-if="$vuetify.breakpoint.mdAndUp"
            :address="myAddress"
          ></doctor-map>
        </v-col>
        <v-col
          v-if="skeletonLoader"
          :cols="$vuetify.breakpoint.mdAndUp ? 6 : 12"
        >
          <v-skeleton-loader
            width="100%"
            type="list-item-avatar-three-line"
          ></v-skeleton-loader>
          <v-skeleton-loader
            v-if="$vuetify.breakpoint.mdAndUp"
            type="list-item-three-line"
          ></v-skeleton-loader>
          <v-skeleton-loader type="card"></v-skeleton-loader>
        </v-col>
        <v-col
          v-if="$vuetify.breakpoint.xsOnly"
          cols="12"
          class="pa-0 book-appointment-bt"
        >
          <v-card flat class="book-appointment-bt">
            <v-card-actions class="pa-0">
              <appointment
                :profile="profile"
                v-if="!isBookingDone && $vuetify.breakpoint.xsOnly"
                @bookingInitiated="bookingInitiated"
                :myAddress="myAddress"
                :bookingDetails="booking"
              ></appointment>
            </v-card-actions>
          </v-card>
        </v-col>
        <v-col
          :cols="$vuetify.breakpoint.mdAndUp ? 6 : 12"
          :class="{ 'px-0': $vuetify.breakpoint.smAndDown }"
        >
          <appointment
            :profile="profile"
            v-if="!isBookingDone && $vuetify.breakpoint.smAndUp"
            @bookingInitiated="bookingInitiated"
            :myAddress="myAddress"
            :bookingDetails="booking"
          ></appointment>
          <availability
            :address="myAddress"
            :bookingTypes="bookingTypes"
          ></availability>
        </v-col>
        <v-col v-if="$vuetify.breakpoint.smAndUp" cols="12" class="pa-0">
          <v-card flat>
            <v-card-actions>
              <appointment
                :profile="profile"
                v-if="!isBookingDone && $vuetify.breakpoint.xsOnly"
                @bookingInitiated="bookingInitiated"
                :myAddress="myAddress"
                :bookingDetails="booking"
              ></appointment>
            </v-card-actions>
          </v-card>
        </v-col>
        <v-col
          v-if="skeletonLoader"
          :cols="$vuetify.breakpoint.mdAndUp ? 6 : 12"
        >
          <v-skeleton-loader
            type="card"
            height="155"
            width="100%"
          ></v-skeleton-loader>
        </v-col>
      </v-row>
    </v-col>
    <v-navigation-drawer
      v-model="isBookingDone"
      app
      right
      temporary
      width="500px"
    >
      <stripe-payment
        :selected="selected"
        :profile="profile"
        :bookingDetails="bookingDetails"
        :slotDetails="slotDetails"
        :isPaymentModal="isBookingDone"
        :recurringBooking="recurringBooking"
        @cancelPayment="cancelPayment"
      ></stripe-payment>
    </v-navigation-drawer>
  </v-row>
  <!-- <v-row class="px-7 py-0">
    <v-col xs="12" sm="12" md="6" lg="6">
      <doctor-details :profile="profile"></doctor-details>
      <doctor-map :address="myAddress"></doctor-map>
    </v-col>
    <v-col cols="12" lg="6" class="py-15">
      <appointment
        :profile="profile"
        @bookingDone="bookingDone"
        v-if="!isBookingDone"
        :myAddress="myAddress"
        :date="booking.date"
        :startHour="booking.startHour"
        :sourceId="booking.sourceId"
        :bookingId="booking.bookingId"
      ></appointment>
      <availability
        :address="myAddress"
        :bookingTypes="bookingTypes"
      ></availability>
      <stripe-payment
        :profile="profile"
        :bookingId="bookingId"
        v-if="isBookingDone"
      ></stripe-payment>
    </v-col>
  </v-row> -->
</template>

<script>
import { DoctorService, BookingService } from "@/services";
import DoctorDetails from "./DoctorDetails";
import DoctorMap from "./DoctorMap";
import Availability from "./Availability";
import Appointment from "./Appointment";
import StripePayment from "./StripePayment";
import moment from "moment";
import { mapGetters } from "vuex";
export default {
  name: "Booking",
  components: {
    DoctorDetails,
    DoctorMap,
    Appointment,
    Availability,
    StripePayment
  },
  computed: {
    ...mapGetters("user", {
      isUserLoggedIn: "isUserLoggedIn"
    })
  },
  data() {
    return {
      profile: {},
      myAddress: {},
      isBookingDone: false,
      booking: {
        date: null,
        startHour: null,
        sourceId: null,
        bookingType: null,
        bookingId: null,
        status: null
      },
      recurringBooking: false,
      bookingDetails: {},
      bookingTypes: [],
      selected: {},
      slotDetails: {},
      skeletonLoader: false
    };
  },
  created() {
    this.getDoctorProfile();
  },
  methods: {
    bookingInitiated(
      object,
      selectedAppointmentType,
      slotDetails,
      recurringBooking
    ) {
      this.bookingDetails = object;
      this.isBookingDone = true;
      this.slotDetails = slotDetails;
      this.selected = selectedAppointmentType;
      this.recurringBooking = recurringBooking;
    },
    /*   bookingDone(id, data) {
      this.isBookingDone = true;
      this.bookingId = id;
      this.selected = data;
    }, */
    cancelPayment() {
      this.isBookingDone = false;
      this.selected = {};
    },
    async getDoctorProfile() {
      this.skeletonLoader = true;
      const response = await DoctorService.getDoctor(
        this.$route.params.doctorId
      );
      if (response.data) {
        if (response.data.data.length < 1) {
          this.$store.dispatch(
            "user/setSnack",
            "Sorry, Can't find doctor's profile"
          );
          this.$store.dispatch("user/setType", "error");
          this.$router.push(`/appointment/list`);
        } else {
          this.profile = response.data.data[0];
          this.myAddress = this.profile.bookingTypes[0].workplaces.find(
            address => {
              if (address._id == this.$route.params.workplaceId) {
                return address;
              }
            }
          );
          this.bookingTypes = this.profile.bookingTypes;
          this.skeletonLoader = false;
        }
      }
      if (this.$route.params.bookingId) {
        const bookingResponse = await BookingService.getBookingById(
          this.$route.params.bookingId
        );
        if (bookingResponse.data) {
          if (bookingResponse.data.data.length < 1) {
            this.$store.dispatch("user/setSnack", "Sorry, Can't find booking!");
            this.$store.dispatch("user/setType", "error");
            this.$router.push(`/appointment/list`);
          } else {
            const data = bookingResponse.data.data[0];
            this.booking.date = moment(data.bookingStartDate).format(
              "YYYY-MM-DD"
            );
            this.booking.startHour = moment(data.bookingStartDate).format(
              "HH:mm"
            );
            this.booking = {
              bookingId: this.$route.params.bookingId,
              sourceId: data.sourceId,
              bookingType: data.bookingTypeObj,
              status: data.status
            };
          }
        }
      }
    }
  }
};
</script>
<style scoped>
.section {
  margin-left: 95px !important;
}
.doctor-title {
  font-family: "Now Alt";
  font-weight: 500;
  font-size: 24px;
  color: #27445b;
}
.paymentcard-style {
  overflow: hidden;
}
.v-navigation-drawer {
  will-change: initial;
  z-index: 999999 !important;
}
.book-appointment-bt {
  height: 60px !important;
}
</style>
